import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';
import '../../Typography/index.js';
import { useTypographySizeContainer } from './hooks/useTypographySizeContainer.js';
import { Typography } from '../../Typography/Typography.js';

var TypographySizeContainer = function TypographySizeContainer(props) {
  var content = useTypographySizeContainer(props);

  // We need to add some character to the DOM for Typography to render with a proper size
  var invisibleCharacter = '|';
  return /*#__PURE__*/React.createElement("span", content.containerStyle, /*#__PURE__*/React.createElement("span", _extends({
    "aria-hidden": true,
    ref: content.textContainerRef
  }, content.textContainerStyle), /*#__PURE__*/React.createElement(Typography, content.typographyProps, invisibleCharacter)), props.children);
};

export { TypographySizeContainer };
//# sourceMappingURL=TypographySizeContainer.js.map
